import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function recommendQuery(query) {
  return query;
}
var ListReconstructionCalculatorClass;
function ListReconstructionCalculator() {
  if (ListReconstructionCalculatorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ListReconstructionCalculator');
    ListReconstructionCalculatorClass = $;
  }
  return ListReconstructionCalculatorClass;
}
//region block: exports
export {
  ListReconstructionCalculator as ListReconstructionCalculator2dt2xl53wlcst,
};
//endregion

//# sourceMappingURL=ListReconstructionCalculator.mjs.map
